import type { GameModule } from './module';

type Loader = () => Promise<{ default: GameModule }>;

/** Game code is loaded on demand, so the catalog page stays light. */
export const LOADERS: Record<string, Loader> = {
  'orbit-duel': () => import('./orbit-duel'),
  'cannon-forts': () => import('./cannon-forts'),
  basketball: () => import('./basketball'),
  soccer: () => import('./soccer'),
  'beach-volleyball': () => import('./beach-volleyball'),
  tennis: () => import('./tennis'),
  golf: () => import('./golf'),
  bowling: () => import('./bowling'),
  'paddle-duel': () => import('./paddle-duel'),
  'air-hockey': () => import('./air-hockey'),
  'slime-volley': () => import('./slime-volley'),
  'neon-trails': () => import('./neon-trails'),
  'sumo-ring': () => import('./sumo-ring'),
  'coin-rush': () => import('./coin-rush'),
  'quick-draw': () => import('./quick-draw'),
  'tug-of-war': () => import('./tug-of-war'),
  'math-duel': () => import('./math-duel'),
  'tic-tac-toe': () => import('./tic-tac-toe'),
  'four-in-a-row': () => import('./four-in-a-row'),
  gomoku: () => import('./gomoku'),
  checkers: () => import('./checkers'),
  reversi: () => import('./reversi'),
  mancala: () => import('./mancala'),
  'dots-and-boxes': () => import('./dots-and-boxes'),
  'memory-match': () => import('./memory-match'),
  'penalty-kicks': () => import('./penalty-kicks'),
  'archery-duel': () => import('./archery-duel'),
  'dodgeball': () => import('./dodgeball'),
  'ice-hockey': () => import('./ice-hockey'),
  'baseball': () => import('./baseball'),
  'word-guess': () => import('./word-guess'),
  'mine-sweep': () => import('./mine-sweep'),
  'solitaire': () => import('./solitaire'),
  'sudoku': () => import('./sudoku'),
  'speed-typer': () => import('./speed-typer'),
  'cookie-factory': () => import('./cookie-factory'),
  'brainrot-heist': () => import('./brainrot-heist'),
  'grow-garden': () => import('./grow-garden'),
  'idle-tycoon': () => import('./idle-tycoon'),
  'tap-hero': () => import('./tap-hero'),
  'snake-arena': () => import('./snake-arena'),
  'cell-eater': () => import('./cell-eater'),
  'territory-grab': () => import('./territory-grab'),
  'black-hole': () => import('./black-hole'),
  'classic-snake': () => import('./classic-snake'),
  'block-drop': () => import('./block-drop'),
  'merge-2048': () => import('./merge-2048'),
  'candy-match': () => import('./candy-match'),
  'bubble-pop': () => import('./bubble-pop'),
  'tile-match': () => import('./tile-match'),
  'maze-muncher': () => import('./maze-muncher'),
  'alien-invasion': () => import('./alien-invasion'),
  'rock-blaster': () => import('./rock-blaster'),
  'brick-breaker': () => import('./brick-breaker'),
  'tower-stack': () => import('./tower-stack'),
  'flap-dash': () => import('./flap-dash'),
  'cube-dash': () => import('./cube-dash'),
  'desert-dino': () => import('./desert-dino'),
  'spring-jumper': () => import('./spring-jumper'),
  'road-hopper': () => import('./road-hopper'),
  'chess': () => import('./chess'),
  'sea-battle': () => import('./sea-battle'),
  'color-cards': () => import('./color-cards'),
  'ludo': () => import('./ludo'),
  'backgammon': () => import('./backgammon'),
  'block-world': () => import('./block-world'),
  'forest-nights': () => import('./forest-nights'),
  'goo-fort': () => import('./goo-fort'),
  'hush-hotel': () => import('./hush-hotel'),
  'desert-rails': () => import('./desert-rails'),
  'raft-drift': () => import('./raft-drift'),
  'disaster-island': () => import('./disaster-island'),
  'pet-buddy': () => import('./pet-buddy'),
  'element-mixer': () => import('./element-mixer'),
  'life-sim': () => import('./life-sim'),
  'kart-racer': () => import('./kart-racer'),
  'bumper-cars': () => import('./bumper-cars'),
  'wobble-race': () => import('./wobble-race'),
  'ink-turf': () => import('./ink-turf'),
  'snowball-fight': () => import('./snowball-fight'),
  'pool-shark': () => import('./pool-shark'),
  'yacht-dice': () => import('./yacht-dice'),
  'darts': () => import('./darts'),
  'monster-tamer': () => import('./monster-tamer'),
  'keep-rush': () => import('./keep-rush'),
  'turbo-ball': () => import('./turbo-ball'),
  'brawl-arena': () => import('./brawl-arena'),
  'stick-scramble': () => import('./stick-scramble'),
  'boxing-ring': () => import('./boxing-ring'),
  'bomb-blast': () => import('./bomb-blast'),
  'rail-runner': () => import('./rail-runner'),
  'sunset-roll': () => import('./sunset-roll'),
  'drift-king': () => import('./drift-king'),
  'moto-stunts': () => import('./moto-stunts'),
  'hill-rider': () => import('./hill-rider'),
  'obby-tower': () => import('./obby-tower'),
  'super-hop': () => import('./super-hop'),
  'pizza-shop': () => import('./pizza-shop'),
  'beat-battle': () => import('./beat-battle'),
  'ship-battle': () => import('./ship-battle'),
  'fruit-slicer': () => import('./fruit-slicer'),
  'slingshot-smash': () => import('./slingshot-smash'),
  'garden-defense': () => import('./garden-defense'),
  'balloon-defense': () => import('./balloon-defense'),
  'aim-trainer': () => import('./aim-trainer'),
  'storm-royale': () => import('./storm-royale'),
  'powder-dash': () => import('./powder-dash'),
  'touchdown-rush': () => import('./touchdown-rush'),
  'volt-trails': () => import('./volt-trails'),
  'blocky-blaster': () => import('./blocky-blaster'),
  'survivor-swarm': () => import('./survivor-swarm'),
  'starship-sneak': () => import('./starship-sneak'),
  'night-shift': () => import('./night-shift'),
};
